module.exports = __webpack_public_path__ + "static/img/kesterpay-logo.476298da.png";